import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosNewMechInstance } from '../../services/api.js';

// Get list of all cars per day +
export const getAllCars = createAsyncThunk(
  'cars/getAllCars',
  async (data, thunkAPI) => {
    try {
      const { target_date, mechanic_id } = data;
      const response = await axiosNewMechInstance.get(`/api/v1/records/`, {
        params: {
          target_date,
          mechanic_id,
          status_view:"all"
        },
      });
      console.log('getAllCars', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Recognize license plate +
export const recognizeLicensePlate = createAsyncThunk(
  'cars/recognizeLicensePlate',
  async (platePhoto, thunkAPI) => {
    console.log('platePhoto', platePhoto);

    try {
      // const formData = new FormData();
      // formData.append('file', platePhoto);
      // console.log('Перевірка перед відправкою:', formData.get('file'));
      const response = await axiosNewMechInstance.post(
        '/api/v1/cars/recognize_plate',
        {image:platePhoto},
        {
          headers: {
            // 'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('recognizeLicensePlate', response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get car info by plate number +
export const getCarInfoByPlateNumber = createAsyncThunk(
  'cars/getCarInfoByPlateNumber',
  async (plate, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/cars/get_car_by_plate?plate=${plate}`
      );
      console.log('getCarInfoByPlateNumber', response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Edit VIN or mileage +
export const editVINorMileage = createAsyncThunk(
  'cars/editVINorMileage',
  async (newData, thunkAPI) => {
    try {
      const { car_id, vin, mileage } = newData;
      const response = await axiosNewMechInstance.post(
        `/api/cars/edit_vin_or_mileage`,
        null,
        {
          params: { car_id, vin, mileage },
        }
      );
      console.log('editVINorMileage', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Diagnostics

// Get Nodes and Parts list +
export const getNodesAndParts = createAsyncThunk(
  'cars/getNodesAndParts',
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/categories_with_parts`
      );
      console.log('getNodesAndParts', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get particular diagnostic +
export const getDiagnostic = createAsyncThunk(
  'cars/getDiagnostic',
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/buffer-diagnostics/${diagnostic_id}`
      );
      console.log('getDiagnostic', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

export const getMainDiagnostic = createAsyncThunk(
  "cars/getMainDiagnostic",
  async (diagnostic_id, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/diagnostics/${diagnostic_id}`,
      );
      // console.log("getAllCars", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  },
);


// Create diagnostic +
export const createDiagnostic = createAsyncThunk(
  'cars/createDiagnostic',
  async (diagnosticData, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.post(
        `/api/v1/buffer-diagnostics/`,
        diagnosticData
      );
      console.log('createDiagnostic', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// create voice diagnostic 
export const createVoiceDiagnostic = createAsyncThunk(
  "cars/createVoiceDiagnostic",
  async (data, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.post(
        `/api/v1/buffer-diagnostics/extract-voice`,
        data,
      );

      console.log("createVoiceDiagnostic", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data?.detail,
      });
    }
  },
);

// Get voice diagnostic result
export const getVoiceDiagnosticResult = createAsyncThunk(
  'cars/getVoiceDiagnosticResult',
  async (task_id, thunkAPI) => {
     try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/buffer-diagnostics/extract-voice/${task_id}`,
      );

      console.log("getVoiceDiagnosticResult", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data?.detail,
      });
    }
  }
)

// ! Repair

// Get repair info +
export const getRepair = createAsyncThunk(
  'cars/getRepair',
  async (repair_id, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/repairs/${repair_id}`
      );
      console.log('getRepair', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update Repair Info +
export const updateRepair = createAsyncThunk(
  'cars/updateRepair',
  async (updatedRepairData, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.company_id;
    try {
      const { repair_id, ...repairData } = updatedRepairData;
      const response = await axiosNewMechInstance.post(
        `/api/v1/buffer-diagnostics/parts/add?repair_id=${repair_id}`,
        repairData,
        {
          headers: {
            'company-id': serviceId,
          },
        }
      );
      console.log('updateRepair', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update part status in repair +
export const updateRepairPartStatus = createAsyncThunk(
  'cars/updateRepairStatus',
  async (dataToUpdate, thunkAPI) => {
    try {
      const { repair_id, part_id, ...data } = dataToUpdate;
      const response = await axiosNewMechInstance.patch(
        `/api/v1/repairs/${repair_id}/parts/${part_id}`,
        data
      );
      console.log('updateRepairStatus', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);


export const updateRepairServiceStatus = createAsyncThunk(
  "cars/updateRepairServiceStatus",
  async (
    dataToUpdate,
    thunkAPI,
  ) => {
    try {
      const { repair_id, service_id, ...data } = dataToUpdate;
      const response = await axiosNewMechInstance.patch(
        `/api/v1/repairs/${repair_id}/services/${service_id}`,
        data,);
      console.log("updateRepairStatus", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  },
);


// ! New car

// Create new car +
export const createNewCar = createAsyncThunk(
  'cars/createNewCar',
  async (carData, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.post(
        `/api/v1/cars/save`,
        carData
      );
      console.log('createNewCar', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Upload car photos +
export const uploadCarPhotos = createAsyncThunk(
  'cars/uploadCarPhotos',
  async (carData, thunkAPI) => {
    try {
      const { car_id, photos } = carData;
      // const formData = new FormData();

      // photos.forEach(photo => {
      //   formData.append('photos', photo);
      // });
      // formData.append('car_id', car_id);
      // formData.append('company_id', serviceId);
      const response = await axiosNewMechInstance.post(
        `/api/v1/cars/upload_car_photos/?record_id=${car_id}`,
        photos
      );
      console.log('uploadCarPhotos', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update existing car +
export const updateCar = createAsyncThunk(
  'cars/updateCar',
  async (carDataToUpdate, thunkAPI) => {
    try {
      const { car_id, ...dataToUpdate } = carDataToUpdate;

      const response = await axiosNewMechInstance.patch(
        `/api/v1/cars/${car_id}`,
        dataToUpdate
      );
      console.log('updateCar', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Get mileage or VIN from photo +
export const getMileageOrVinFromPhoto = createAsyncThunk(
  'cars/getMileageOrVinFromPhoto',
  async (photo, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.post(
        '/api/v1/cars/extract/openai',
        { image: photo }
      );
      console.log('getMileageOrVinFromPhoto', response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// vin / mileage recognition result
export const getMileageOrVinFromPhotoResult = createAsyncThunk(
  'cars/getMileageOrVinFromPhotoResult',
  async (task_id, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/cars/extract/openai/${task_id}`
      );
      console.log('getMileageOrVinFromPhotoResult', response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Upload media to convert +
export const uploadMedia = createAsyncThunk(
  'cars/uploadMedia',
  async (media, thunkAPI) => {
    try {
      // media_types: {"photos": "jpg", "audios": "mp3", "videos": "mp4"}
      const response = await axiosNewMechInstance.post(
        `/api/cars/upload_media/`,
        media
      );
      console.log('uploadMedia', response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
